var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedallions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_48_2064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3867 2.5359C27.7213 2.18734 28.2787 2.18734 28.6133 2.5359L33.1287 7.2398C33.337 7.45683 33.6446 7.5476 33.9374 7.47848L40.252 5.98791C40.7203 5.87736 41.1869 6.17715 41.281 6.64902L42.5656 13.0886C42.6239 13.381 42.8312 13.6215 43.1119 13.7224L49.2362 15.9226C49.6855 16.0841 49.9139 16.5839 49.7417 17.0293L47.3718 23.1596C47.2651 23.4358 47.3097 23.7476 47.4896 23.9827L51.4726 29.1898C51.7621 29.5682 51.6841 30.1107 51.2997 30.3922L46.0302 34.2515C45.7907 34.4269 45.6601 34.7145 45.6855 35.0103L46.2494 41.5625C46.2905 42.04 45.929 42.4571 45.4505 42.4842L38.9696 42.8517C38.6704 42.8687 38.4022 43.0419 38.2637 43.3077L35.2396 49.1128C35.0167 49.5408 34.4825 49.6976 34.0636 49.458L28.4221 46.2314C28.1606 46.0818 27.8394 46.0818 27.5779 46.2314L21.9364 49.458C21.5175 49.6976 20.9833 49.5408 20.7604 49.1128L17.7363 43.3077C17.5978 43.0419 17.3296 42.8687 17.0304 42.8517L10.5495 42.4842C10.071 42.4571 9.70946 42.04 9.75055 41.5625L10.3145 35.0103C10.3399 34.7145 10.2093 34.4269 9.96978 34.2515L4.70034 30.3922C4.31594 30.1107 4.23793 29.5682 4.52742 29.1898L8.51044 23.9827C8.69031 23.7476 8.7349 23.4358 8.62815 23.1596L6.25832 17.0293C6.08614 16.5839 6.31446 16.0841 6.76385 15.9226L12.8881 13.7224C13.1688 13.6215 13.3761 13.381 13.4344 13.0886L14.719 6.64902C14.8131 6.17715 15.2797 5.87736 15.748 5.98791L22.0626 7.47848C22.3554 7.5476 22.663 7.45683 22.8713 7.2398L27.3867 2.5359Z",
    fill: "url(#paint0_linear_48_2064)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7837 26.3206C11.7837 17.1306 19.2337 9.68066 28.4237 9.68066C37.6136 9.68066 45.0636 17.1306 45.0636 26.3206V26.6628C45.0636 35.8528 37.6136 43.3028 28.4237 43.3028C19.2337 43.3028 11.7837 35.8528 11.7837 26.6628V26.3206Z",
    fill: "black",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1011 26.3206C12.1011 17.3059 19.409 9.9981 28.4237 9.9981C37.4383 9.9981 44.7462 17.3059 44.7462 26.3206V26.6628C44.7462 35.6775 37.4383 42.9854 28.4237 42.9854C19.409 42.9854 12.1011 35.6775 12.1011 26.6628V26.3206Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.634869
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6272 29.513L22.4321 26.2851C22.2601 26.111 22.0265 26.0131 21.783 26.0131C21.5394 26.0131 21.3059 26.111 21.1338 26.2851C20.7747 26.6479 20.7747 27.234 21.1338 27.5968L24.9826 31.4851C25.3417 31.8479 25.9218 31.8479 26.2809 31.4851L36.0226 21.6433C36.3817 21.2805 36.3817 20.6944 36.0226 20.3317C35.8506 20.1575 35.617 20.0596 35.3734 20.0596C35.1299 20.0596 34.8963 20.1575 34.7243 20.3317L25.6272 29.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6272 29.513L22.4321 26.2851C22.2601 26.111 22.0265 26.0131 21.783 26.0131C21.5394 26.0131 21.3059 26.111 21.1338 26.2851C20.7747 26.6479 20.7747 27.234 21.1338 27.5968L24.9826 31.4851C25.3417 31.8479 25.9218 31.8479 26.2809 31.4851L36.0226 21.6433C36.3817 21.2805 36.3817 20.6944 36.0226 20.3317C35.8506 20.1575 35.617 20.0596 35.3734 20.0596C35.1299 20.0596 34.8963 20.1575 34.7243 20.3317L25.6272 29.513Z",
    stroke: "#FDFDFD",
    strokeWidth: 0.126974
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6272 29.513L22.4321 26.2851C22.2601 26.111 22.0265 26.0131 21.783 26.0131C21.5394 26.0131 21.3059 26.111 21.1338 26.2851C20.7747 26.6479 20.7747 27.234 21.1338 27.5968L24.9826 31.4851C25.3417 31.8479 25.9218 31.8479 26.2809 31.4851L36.0226 21.6433C36.3817 21.2805 36.3817 20.6944 36.0226 20.3317C35.8506 20.1575 35.617 20.0596 35.3734 20.0596C35.1299 20.0596 34.8963 20.1575 34.7243 20.3317L25.6272 29.513Z",
    stroke: "url(#paint1_linear_48_2064)",
    strokeWidth: 0.126974
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1558 11.4372C28.1558 10.4671 28.9446 9.67075 29.9089 9.77645C32.8064 10.094 35.5797 11.1947 37.9341 12.979C40.7599 15.1206 42.8315 18.1329 43.8412 21.5682C44.851 25.0036 44.7449 28.6789 43.5388 32.048C42.3326 35.4172 40.0908 38.3004 37.1464 40.2695C34.2019 42.2386 30.7119 43.1885 27.1948 42.978C23.6776 42.7675 20.3211 41.4079 17.6236 39.1012C14.9262 36.7944 13.0319 33.6636 12.2221 30.1738C11.545 27.2561 11.6562 24.2176 12.5281 21.3763C12.811 20.4543 13.8501 20.0478 14.7329 20.4363C15.5997 20.8178 15.9869 21.8236 15.7313 22.7355C15.128 24.8873 15.0717 27.1702 15.5813 29.3663C16.2204 32.1204 17.7154 34.5911 19.8441 36.4115C21.9728 38.232 24.6218 39.3049 27.3974 39.471C30.173 39.6372 32.9273 38.8876 35.2509 37.3336C37.5746 35.7796 39.3438 33.5042 40.2956 30.8454C41.2475 28.1866 41.3312 25.2862 40.5343 22.575C39.7375 19.8639 38.1026 17.4867 35.8726 15.7966C34.1143 14.4641 32.0601 13.6147 29.9068 13.315C28.946 13.1812 28.1558 12.4073 28.1558 11.4372Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_48_2064",
    x: 0.0925143,
    y: 0.594477,
    width: 55.815,
    height: 55.815,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.60499
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.95374
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.983523 0 0 0 0 0.811406 0 0 0 0 0.904349 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_48_2064"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_48_2064",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_48_2064",
    x1: 12.4281,
    y1: 6.39196,
    x2: 38.7559,
    y2: 47.8903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E0ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109389,
    stopColor: "#BFC8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463563,
    stopColor: "#CBCDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739611,
    stopColor: "#C3ADCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9699B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_48_2064",
    x1: 23.5733,
    y1: 21.155,
    x2: 29.1142,
    y2: 32.6733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E0ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109389,
    stopColor: "#BFC8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#F2DEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557292,
    stopColor: "#CBCDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#D5B8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9699B5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedallions);
export default __webpack_public_path__ + "static/media/Medallions.cc28c6a7d1c42a2a261d04483e91e172.svg";
export { ForwardRef as ReactComponent };